{
  "49": {
    "charts": [
      {
        "title": "total_bookings_per_month",
        "channel": "SummaryPerMonth",
        "key": "totalBooking",
        "type": "bar"
      },
      {
        "title": "users_per_mail_address",
        "channel": "CountOfUsersPerMembership",
        "type": "pie"
      }
    ]
  }
}
